import { render, staticRenderFns } from "./TyProductProduct.vue?vue&type=template&id=85f4906e&scoped=true&"
import script from "./TyProductProduct.vue?vue&type=script&lang=js&"
export * from "./TyProductProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f4906e",
  null
  
)

export default component.exports